module.exports = __webpack_public_path__ + "static/media/web_1-2.fcef87b0.jpg";